import { types } from 'mobx-state-tree';
import CustomFormField from '../../CustomFormField';
import Order from '../Order';
import OrderExtraField from '../OrderExtraField';
import OrderProposalProduct from './OrderProposalProduct';

// This probably becomes obsolete in the near future.
// For now to get the proposal page to work
const OrderProposal = types
  .compose(
    Order,
    types.model('OrderProposal', {
      campaign_code: types.maybeNull(types.string),
      customer_fields: types.maybeNull(types.array(CustomFormField)),
      external_type: types.maybeNull(types.string),
      extra_fields: types.array(OrderExtraField),
      id_for_analytics: types.string,
      lang: types.string,
      merchant_name: types.maybeNull(types.string),
      new_product_info: types.maybeNull(OrderProposalProduct),
      payment_method_messages: types.optional(types.array(types.string), []),
      products: types.array(OrderProposalProduct),
      real_total: types.number,
      removed_products: types.array(OrderProposalProduct),
      separate_shipping_address_active: types.boolean,
      show_prices: types.boolean,
      tracking_code: types.string,
    })
  )
  .named('OrderProposal');

export default OrderProposal;
